import React, { useState } from 'react'
import FormError from '../Forms/FormError/FormError'

export default function Question({ label, value, options, name, className, required = false, multiselect = false, error, onChange = () => { } }) {
    const onSelect = v => {
        if (multiselect) {
            if (value?.includes(v)) {
                v = value.filter(i => i != v)
            } else {
                v = [...(value || []), v]
            }
        }
        const target = { name, value: v }
        onChange({ target, currentTarget: target })
    }

    let classes = "question"
    if (className) {
        classes += " " + className
    }

    return (
        <div className={classes}>
            <label className="question-label" htmlFor={name}>
                {label} {required && <span className="text-red">*</span>}
                {multiselect && <div style={{ color: 'var(--neutral-700)', fontWeight: 400, fontSize: 14, lineHeight: '20px' }}>Select all that apply</div>}
            </label>

            {!!options?.length && <div className="question-options" name={name}>
                {options.map((option, index) => {
                    let classes = "question-option"
                    const optionValue = typeof option === 'object' ? option.value : option
                    if (multiselect) {
                        if (value?.includes(optionValue)) {
                            classes += " question-option-selected"
                        }
                    } else {
                        if (value == optionValue) {
                            classes += " question-option-selected"
                        }
                    }
                    return (
                        <div key={index} className={classes} onClick={() => onSelect(optionValue)}>
                            <span>{option.label || option}</span>
                        </div>
                    )
                })}
            </div>}
            {!!error && <FormError>{error}</FormError>}
        </div>
    )
}